module.exports = __webpack_public_path__ + "static/img/sqz.74282e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sqz.png
// module id = PM7M
// module chunks = 1